/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Chat_Rate_LimitedInputs */

const en_us2_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many messages in a short time. Wait a little.`)
};

const pt_br2_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas mensagens em pouco tempo. Espere um pouco.`)
};

const es_419_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiados mensajes en poco tiempo. Espera un poco.`)
};

const pt_pt2_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas mensagens em pouco tempo. Espera um pouco.`)
};

const fr_fr2_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de messages en peu de temps. Patiente un peu.`)
};

const de_de2_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Nachrichten in kurzer Zeit. Warte kurz.`)
};

const it_it2_club_chat_rate_limited = /** @type {(inputs: Club_Chat_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppi messaggi in poco tempo. Aspetta un po'.`)
};

/**
* | output |
* | --- |
* | "Too many messages in a short time. Wait a little." |
*
* @param {Club_Chat_Rate_LimitedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_chat_rate_limited = /** @type {((inputs?: Club_Chat_Rate_LimitedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Chat_Rate_LimitedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_chat_rate_limited(inputs)
	if (locale === "es-419") return es_419_club_chat_rate_limited(inputs)
	if (locale === "pt-PT") return pt_pt2_club_chat_rate_limited(inputs)
	if (locale === "fr-FR") return fr_fr2_club_chat_rate_limited(inputs)
	if (locale === "de-DE") return de_de2_club_chat_rate_limited(inputs)
	if (locale === "it-IT") return it_it2_club_chat_rate_limited(inputs)
	return en_us2_club_chat_rate_limited(inputs)
});
export { club_chat_rate_limited as "club.chat_rate_limited" }